(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oma-face-intro"] && !Shopify.designMode) return;
  try {
    (function(){
  function initFace(root){
    if(root.dataset.faceReady)return;
    root.dataset.faceReady='true';
    var filters=root.parentElement.querySelector('#shopFilters');
    if(filters){
      var selected=filters.querySelector('.sf-btn.on');
      if(selected)root.hidden=selected.getAttribute('data-tag')!=='face';
      filters.addEventListener('click',function(event){var button=event.target.closest('.sf-btn');if(button&&filters.contains(button))root.hidden=button.getAttribute('data-tag')!=='face'});
    }
    var tiles=Array.from(root.querySelectorAll('[data-face-tile]'));
    tiles.forEach(function(tile){tile.addEventListener('click',function(){var open=tile.getAttribute('aria-pressed')!=='true';tiles.forEach(function(t){t.setAttribute('aria-pressed','false')});tile.setAttribute('aria-pressed',String(open))});tile.addEventListener('keydown',function(e){if(e.key==='Escape'){tile.setAttribute('aria-pressed','false');tile.blur()}})});
    var dialog=root.querySelector('dialog'),form=root.querySelector('[data-face-form]'),questions=Array.from(form.querySelectorAll('[data-face-question]')),result=root.querySelector('[data-face-result]'),step=0;
    function showStep(focus){questions.forEach(function(q,i){q.hidden=i!==step});form.querySelector('[data-face-step]').textContent=String(step+1);form.querySelector('[data-face-back]').hidden=step===0;form.querySelector('[data-face-continue]').hidden=step===2;form.querySelector('[data-face-see]').hidden=step!==2;form.querySelector('[data-face-error]').hidden=true;if(focus)questions[step].querySelector('legend').focus()}
    function reset(){form.reset();step=0;form.hidden=false;result.hidden=true;showStep(false)}
    root.querySelectorAll('[data-face-open]').forEach(function(opener){opener.addEventListener('click',function(){reset();dialog.showModal();questions[0].querySelector('legend').focus()})});
    root.querySelector('[data-face-close]').addEventListener('click',function(){dialog.close()});
    form.querySelector('[data-face-back]').addEventListener('click',function(){step=Math.max(0,step-1);showStep(true)});
    form.addEventListener('submit',function(event){
      event.preventDefault();
      if(!questions[step].querySelector('input:checked')){form.querySelector('[data-face-error]').hidden=false;questions[step].querySelector('input').focus();return}
      if(step<2){step++;showStep(true);return}
      var feel=form.querySelector('[name="feel"]:checked').value,goal=form.querySelector('[name="goal"]:checked').value,response=form.querySelector('[name="response"]:checked').value;
      var grace=(feel==='dry'?2:0)+(goal==='nourish'?1:0),resolve=(feel==='oily'?2:0)+(goal==='balance'?1:0);
      var match=response!=='comfortable'?'none':grace===resolve?'both':grace>resolve?'grace':'resolve';
      form.hidden=true;result.hidden=false;result.querySelectorAll('[data-face-case]').forEach(function(c){c.hidden=c.dataset.faceCase!==match});result.querySelector('[data-face-case="'+match+'"] h3').focus();
    });
    root.querySelector('[data-face-restart]').addEventListener('click',function(){reset();questions[0].querySelector('legend').focus()});
  }
  function initAll(){document.querySelectorAll('[data-oma-face]').forEach(initFace)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oma-phytoblend"] && !Shopify.designMode) return;
  try {
    (function(){
  function initPhyto(root){
    if(root.dataset.phytoReady)return;
    root.dataset.phytoReady='true';
    var filters=root.parentElement.querySelector('#shopFilters');
    if(filters){
      var selected=filters.querySelector('.sf-btn.on');
      if(selected)root.hidden=selected.getAttribute('data-tag')!=='body';
      filters.addEventListener('click',function(event){var button=event.target.closest('.sf-btn');if(button&&filters.contains(button))root.hidden=button.getAttribute('data-tag')!=='body';});
    }
    var track=root.querySelector('[data-phyto-track]');
    var cards=Array.from(root.querySelectorAll('[data-phyto-card]'));
    var prev=root.querySelector('[data-phyto-prev]');
    var next=root.querySelector('[data-phyto-next]');
    var range=root.querySelector('[data-phyto-range]');
    var label=root.querySelector('[data-phyto-range-label]').content.textContent;
    function updateRange(){
      if(!track.clientWidth)return;
      var bounds=track.getBoundingClientRect();
      var visible=cards.map(function(card,i){var rect=card.getBoundingClientRect();return rect.left>=bounds.left-5&&rect.left<bounds.right-10?i:-1;}).filter(function(i){return i>=0;});
      if(visible.length)range.textContent=label.replace('__FIRST__',visible[0]+1).replace('__LAST__',visible[visible.length-1]+1);
      prev.disabled=track.scrollLeft<5;
      next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-5;
    }
    function move(direction){track.scrollBy({left:direction*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
    prev.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    track.addEventListener('scroll',updateRange,{passive:true});
    cards.forEach(function(card){card.addEventListener('click',function(){var open=card.getAttribute('aria-pressed')!=='true';cards.forEach(function(c){c.setAttribute('aria-pressed','false')});card.setAttribute('aria-pressed',String(open));});});
    var resize=new ResizeObserver(updateRange);resize.observe(track);updateRange();
  }
  function initAll(){document.querySelectorAll('[data-oma-phyto]').forEach(initPhyto)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oma-scent-library"] && !Shopify.designMode) return;
  try {
    (function(){
  function initScent(root){
    if(root.dataset.scentReady)return;
    root.dataset.scentReady='true';
    var filters=root.parentElement.querySelector('#shopFilters');
    if(filters){
      var selected=filters.querySelector('.sf-btn.on');
      if(selected)root.hidden=selected.getAttribute('data-tag')!=='perfume';
      filters.addEventListener('click',function(event){
        var button=event.target.closest('.sf-btn');
        if(button&&filters.contains(button))root.hidden=button.getAttribute('data-tag')!=='perfume';
      });
    }
    var tiles=Array.from(root.querySelectorAll('[data-scent-tile]'));
    tiles.forEach(function(tile){
      tile.addEventListener('click',function(){
        var open=tile.getAttribute('aria-pressed')!=='true';
        tiles.forEach(function(item){item.setAttribute('aria-pressed','false')});
        tile.setAttribute('aria-pressed',String(open));
      });
      tile.addEventListener('keydown',function(event){if(event.key==='Escape'){tile.setAttribute('aria-pressed','false');tile.blur()}});
    });
  }
  function initAll(){document.querySelectorAll('[data-oma-scent]').forEach(initScent)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oma-shower-intro"] && !Shopify.designMode) return;
  try {
    (function(){
  function initShower(root){
    if(root.dataset.showerReady)return;
    root.dataset.showerReady='true';
    var filters=root.parentElement.querySelector('#shopFilters');
    if(filters){
      var selected=filters.querySelector('.sf-btn.on');
      if(selected)root.hidden=selected.getAttribute('data-tag')!=='cleanser';
      filters.addEventListener('click',function(event){
        var button=event.target.closest('.sf-btn');
        if(button&&filters.contains(button))root.hidden=button.getAttribute('data-tag')!=='cleanser';
      });
    }
    var tiles=Array.from(root.querySelectorAll('[data-shower-tile]'));
    tiles.forEach(function(tile){
      tile.addEventListener('click',function(){
        var open=tile.getAttribute('aria-pressed')!=='true';
        tiles.forEach(function(item){item.setAttribute('aria-pressed','false')});
        tile.setAttribute('aria-pressed',String(open));
      });
      tile.addEventListener('keydown',function(event){if(event.key==='Escape'){tile.setAttribute('aria-pressed','false');tile.blur()}});
    });
  }
  function initAll(){document.querySelectorAll('[data-oma-shower]').forEach(initShower)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oma-steamer-intro"] && !Shopify.designMode) return;
  try {
    (function(){
  function initSteamer(root){
    if(root.dataset.steamerReady)return;
    root.dataset.steamerReady='true';
    var filters=root.parentElement.querySelector('#shopFilters');
    if(filters){
      var selected=filters.querySelector('.sf-btn.on');
      if(selected)root.hidden=selected.getAttribute('data-tag')!=='steamer';
      filters.addEventListener('click',function(event){
        var button=event.target.closest('.sf-btn');
        if(button&&filters.contains(button))root.hidden=button.getAttribute('data-tag')!=='steamer';
      });
    }
    var tiles=Array.from(root.querySelectorAll('[data-steamer-tile]'));
    tiles.forEach(function(tile){
      tile.addEventListener('click',function(){
        var open=tile.getAttribute('aria-pressed')!=='true';
        tiles.forEach(function(item){item.setAttribute('aria-pressed','false')});
        tile.setAttribute('aria-pressed',String(open));
      });
      tile.addEventListener('keydown',function(event){if(event.key==='Escape'){tile.setAttribute('aria-pressed','false');tile.blur()}});
    });
  }
  function initAll(){document.querySelectorAll('[data-oma-steamer]').forEach(initSteamer)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
